export const vendorPermissions = {
    VIEW_VENDORS: {
        key: 'vendors.view',
        name: 'View Vendors'
    },
    MANAGE_VENDORS: {
        key: 'vendors.manage',
        name: 'Manage Vendors'
    },
    ADD_FEEDBACK: {
        key: 'vendors.feedback.add',
        name: 'Add Feedback'
    }
};